import './FooterComponent.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedin, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

function FooterComponent() {
    return (
        <div className="App-footer">
            <div className='App-footer-icon_container'>
                <a target="_blank" rel="noopener noreferrer" aria-label="Instagram" href="https://www.instagram.com/lic.natalia.saenz?igsh=MTdwMGFsaXVuOHE3bw=="><FontAwesomeIcon icon={faInstagram} /></a>
                <a target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" href="https://www.linkedin.com/in/saenznatalia"><FontAwesomeIcon icon={faLinkedin} /></a>
                <a target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" href="https://wa.me/1533584891"><FontAwesomeIcon icon={faWhatsapp} /></a>
            </div>
            <ul>
                <li><a href="#home" aria-label="Inicio">Home</a></li>
                <li><a href="#sobremi" aria-label="Sobre mi">Sobre Mi</a></li>
                <li><a href="#servicios" aria-label="Servicios">Servicios</a></li>
                <li><a href="#contacto" aria-label="Contacto">Contacto</a></li>
            </ul>
            
        </div>
    );
}

export default FooterComponent;